import { Ref } from 'react';
import isEqual from 'lodash/isEqual';
import { hofForwardRef } from '../../utils/types';
import SwitchiOS from '../SwitchiOS';
import * as TwoStateSwitchUI from './TwoStateSwitchUI';

export interface TwoStateOption<T> {
  label: JSX.Element | string;
  value: T;
}

interface IProps<T> extends Partial<Pick<HTMLElement, 'className'>> {
  selectedValue: T;
  options: [TwoStateOption<T>, TwoStateOption<T>];
  onChange: (selectedValue: T, event: React.MouseEvent<HTMLElement>) => unknown;
}

export type ITwoStateSwitchOnChange<T> = IProps<T>['onChange'];

export const TwoStateSwitch = hofForwardRef(
  <T, H extends HTMLDivElement>(
    { options, onChange, selectedValue, className }: IProps<T>,
    ref: Ref<H>,
  ) => {
    if (
      !isEqual(selectedValue, options[0].value) &&
      !isEqual(selectedValue, options[1].value)
    ) {
      console.warn(
        `TwoStateSwitch: selectedValue ${selectedValue} is neither of the 2 options: `,
        options,
      );
    }
    return (
      <TwoStateSwitchUI.Wrapper className={className} ref={ref}>
        <TwoStateSwitchUI.Option
          type="button"
          onClick={(e) => onChange(options[0].value, e)}
          $isActive={isEqual(selectedValue, options[0].value)}
        >
          {options[0].label}
        </TwoStateSwitchUI.Option>
        <SwitchiOS
          isChecked={isEqual(selectedValue, options[1].value)}
          onClick={(e) =>
            onChange(
              isEqual(selectedValue, options[1].value)
                ? options[0].value
                : options[1].value,
              e,
            )
          }
        />
        <TwoStateSwitchUI.Option
          type="button"
          onClick={(e) => onChange(options[1].value, e)}
          $isActive={isEqual(selectedValue, options[1].value)}
        >
          {options[1].label}
        </TwoStateSwitchUI.Option>
      </TwoStateSwitchUI.Wrapper>
    );
  },
);
